var React = require('react');

function MajorLeaf (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M20.47 2a1.5 1.5 0 0 1 1.24.69 1.5 1.5 0 0 1 .11 1.43c-.72 1.72-4.55 10.24-7 12a6 6 0 0 1-3.55 1.11 7.17 7.17 0 0 1-4.84-1.92 17.45 17.45 0 0 0-2.7 6.13A.76.76 0 0 1 3 22a.63.63 0 0 1-.23-.07.75.75 0 0 1-.54-.91 18.87 18.87 0 0 1 3.15-6.9 6.64 6.64 0 0 1-1-5 6 6 0 0 1 2.69-4C11.33 2.44 20.04 2 20.4 2h.07zm-9.15 13.72a4.57 4.57 0 0 0 2.68-.83c2.19-1.61 6.47-11.35 6.47-11.35s-8.6.39-12.6 2.89a4.83 4.83 0 0 0-1.38 6.53 34.149 34.149 0 0 1 5.9-4.79.75.75 0 0 1 1 .2.74.74 0 0 1-.19 1 31.372 31.372 0 0 0-5.78 4.77 5.76 5.76 0 0 0 3.9 1.58z","fill":"#000"}));
}

MajorLeaf.defaultProps = {"width":"40","height":"40","viewBox":"0 0 24 24","fill":"none"};

module.exports = MajorLeaf;

MajorLeaf.default = MajorLeaf;
